import './tags.module';
import './$tags.factory';
import './tags.config';

import './components';
import './constants';
import './services';
import './angular/types';
